import { Fragment } from "react";
import DataTable from "react-data-table-component";
import { Badge } from "reactstrap";
import {
  dateTimeFieldToDate,
  formatRP,
  getDateToday,
} from "../../../../Utils/externalFunctions";
import { useThemeContext } from "../../../../Context/ThemeContext";
import { customStyles } from "../../../DataTableComponents/CustomStyle";

const ListUMK = ({
  data,
  columns,
  totalUMK,
  subHeaderComponent,
  pending,
  resetPaginationToggle,
}) => {
  const { themeContext } = useThemeContext();

  const conditionalRowStyles = [
    {
      when: (row) =>
        dateTimeFieldToDate(row.date_created) === getDateToday("original"),
      style: (row) => ({
        backgroundColor: row.diajukan_oleh ? "pink" : "red",
      }),
    },
  ];

  return (
    <Fragment>
      <h4 className="text-center">Total Nilai UMK</h4>
      <h5 className="text-center">
        <Badge color="success">Rp. {formatRP(totalUMK)}</Badge>
      </h5>
      <DataTable
        columns={columns}
        data={data}
        pagination
        paginationResetDefaultPage={resetPaginationToggle}
        selectableRowsHighlight
        highlightOnHover
        subHeader
        customStyles={customStyles}
        conditionalRowStyles={conditionalRowStyles}
        subHeaderComponent={subHeaderComponent}
        subHeaderAlign="right"
        persistTableHead
        progressPending={pending}
        theme={themeContext}
      />
    </Fragment>
  );
};

export default ListUMK;
